export default __webpack_public_path__ + "file/Brochure-Puroak-FR.asset.180ad4cb.pdf";